module.exports = __webpack_public_path__ + "img/yqh5.684c9c56.jpg";